package com.ustadmobile.core.db.dao

object CourseGroupSetDaoConstants {

    const val SORT_NAME_ASC = 1

    const val SORT_NAME_DESC = 2

}